import React, {useEffect, useState} from "react";
import Pagination from "react-js-pagination";
import {NavLink, useLocation} from "react-router-dom";
import { useHistory } from "react-router";
import MetaTags from "react-meta-tags";
import BreadCrumb from '../Layout/Funlove/BreadCrumb';

import {FormatNumber, CreateParame} from "../Lib/helper";
import {activeOrderLink} from './Components/ActiveLink';
import {activeMenu} from "./Components";
import BoxAds from "./Components/BoxAds";

function errorNotfound(props) {

    let history = useHistory();
    const location = useLocation();

    useEffect(() => {

        activeMenu('#home');
    }, [location]);


    return (
        <>
            <MetaTags>
                <title>Movise JAV Free Porn Video, Watch Online, Jav HD</title>
                <meta name="description"
                      content="UNCENSORED FREE Online Watching Uncensored, Jav Censored, Uncensored Japanese Porn FREE Streaming"/>
                <link rel="canonical" href="https://funlove.info/movies/"/>
                <meta property="og:locale" content="en_us"/>
                <meta property="og:type" content="website"/>
                <meta property="og:title"
                      content="UNCENSORED JAV Free Porn Video, Watch Online, Jav HD"/>
                <meta property="og:description"
                      content="UNCENSORED FREE Online Watching Uncensored, Jav Censored, Uncensored Leaked Japanese Porn FREE Streaming"/>
                <meta property="og:url" content="https://funlove.info/movies/"/>
                <meta property="og:site_name" content="Funlove"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title"
                      content="UNCENSORED JAV Free Porn Video, Watch Online, Jav HD"/>
                <meta name="twitter:description"
                      content="UNCENSORED FREE Online Watching Uncensored, Jav Censored, Uncensored Leaked Japanese Porn FREE Streaming"/>
                <meta name="twitter:site" content="@funlove"/>

            </MetaTags>
            <BreadCrumb/>

            <section className="breadcrumb-wrapper visible-md-block visible-lg-block">
                <div className="container">
                    <ol className="breadcrumb">
                        <li>
                            <NavLink to='/' title='Home'>
                                <i className="glyphicon glyphicon-home"></i> Home
                            </NavLink>
                        </li>
                        <li className="active"> 404</li>
                    </ol>
                </div>
            </section>
            <BoxAds></BoxAds>
            <div className="container">
                <div className="error404">
                    <strong>Not Found</strong>
                    <p>
                        The page you are looking for does not exist. You may have used an outdated link or may have typed
                        the URL incorrectly.
                    </p>


                    <NavLink
                        to="/"
                        title="Back to home"
                        className="btn btn-primary"

                    >
                        Back to home ▸
                    </NavLink>
                </div>
            </div>
            <BoxAds></BoxAds>
        </>
    )
}

export default errorNotfound;
